export class ChatMessage {
    constructor({ id, status, contentType, senderId, direction, content, createdTime = new Date(), updatedTime, position = "normal", seen = 0, messagedId, groupContentDate, file, files }) {
        this.id = void 0;
        this.status = void 0;
        this.contentType = void 0;
        this.senderId = void 0;
        this.direction = void 0;
        this.content = void 0;
        this.createdTime = void 0;
        this.updatedTime = void 0;
        this.position = void 0;
        this.seen = void 0;
        this.messagedId = void 0;
        this.groupContentDate = void 0;
        this.file = void 0;
        this.files = void 0;
        this.id = id;
        this.status = status;
        this.contentType = contentType;
        this.senderId = senderId;
        this.direction = direction;
        this.content = content;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.position = position;
        this.seen = seen;
        this.messagedId = messagedId;
        this.groupContentDate = groupContentDate;
        this.file = file;
        this.files = files;
    }
}
